<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "awaitingReceiptItem",
  setup() {},
  data() {
      return {
          openDialog: false,
          selected: [],
      }
  },
  props: {
    item: Object,
  },
  methods: {
    receiveItem({ evt, ...newInfo }) {
        if (parseInt(this.consignmentPermission) < 3) {
            return;
        }
        try {
            var i = evt.srcElement.attributes['data-po'].nodeValue;
            this.$store.commit('consignment/setSelectedReceive', i)
        }catch(e) {
            this.$store.dispatch('message/sendMessage', {message: `Receive Item Selection Error - ${e}`, type:'negative', position: 'bottom', icon: 'fa fa-check'}, {root:true});
        }

    },
  },
  computed: {
      selectedReceive() {
          return this.$store.getters['consignment/selectedReceive']
      },
      isSelected() {
          return this.selectedReceive.includes(this.item.ticketNumber) ? true : false;
      },
      consignmentPermission() {
        return this.$store.getters["auth/consignmentPermission"];
      },
  }
});
</script>


<template>
  <div v-bind:class="[isSelected ? 'q-pa-sm consignmentReceive' : 'q-pa-sm']">
    <div class="row">
        <div class="col-6">
            <h2 class="wcwH">{{item.itemNumber}} <q-btn v-if="item.tracking!=null" @click="openDialog=true" size="sm" flat round color="positive" icon="fal fa-truck" /></h2> 
            <p class="productDescription">{{item.description}}</p>
        </div>
        <div class="col-6 text-center">
            <button type="button" class="btn btn-consignment btn-awaiting btn-sm q-mr-sm">
            <span>Status</span>{{item.status}}
            </button>
            <button type="button" class="btn btn-consignment btn-awaiting btn-sm">
            <span>Qty</span>{{item.qty}} {{item.uom}}
            </button>
        </div>
    </div>
    <div class="row q-mt-sm text-center" style="position: relative;" >
        <span v-if="item.ticketNumber.length>0 && item.invoiceNumber.length>0" class="selectHitBox" v-touch-hold:300.mouse="receiveItem" :data-po="`${item.ticketNumber}`"></span>
            <div class="col-3">
                <button type="button" class="btn btn-consignment btn-awaiting btn-sm">
                <span>Order</span><div class="btn-consignment-val">{{item.orderNumber}}</div>
                </button>
            </div>
            <div class="col-3" v-if="item.po.length>0">
                <button type="button" class="btn btn-consignment btn-awaiting btn-sm">
                <span>PO</span><div class="btn-consignment-val">{{item.po}}</div>
                </button>
            </div>
            <div class="col-3" v-if="item.invoiceNumber.length>0">
                <button type="button" class="btn btn-consignment btn-awaiting btn-sm">
                <span>Invoice</span><div class="btn-consignment-val">{{item.invoiceNumber}}</div>
                </button>
            </div>
            <div class="col-3" v-if="item.ticketNumber.length>0">
                <button type="button" class="btn btn-consignment btn-awaiting btn-sm">
                <span>Ticket</span><div class="btn-consignment-val">{{item.ticketNumber}}</div>
                </button>
            </div>
    </div>
  </div>

    <!-- Shipping Details Modal -->
    <q-dialog v-model="openDialog" square :no-esc-dismiss=true :no-backdrop-dismiss=true :dense=true>
        <q-card class="WCWContainer" style="height: auto;padding:0;">
            <q-card-section class="text-center q-pa-none q-ma-none">
                <div class="row" style="display: table; width: 100%;">
                    <h2 class="wcwBlue">Tracking Info</h2>
                    <span>
                        <q-btn class="absolute absolute-right" icon="close" flat round dense v-close-popup />
                    </span>
                </div>
            </q-card-section>
            <q-card-section class="text-center q-pt-none q-ma-none">
                <div><span class="strong">Carrier:</span> {{item.tracking[0].carrier}}</div>
                <div v-if="item.tracking[0].carrier.toUpperCase().includes('UPS')"><span class="strong">Tracking: </span><a class="link text-cyan-7" :href="`https://wwwapps.ups.com/tracking/tracking.cgi?tracknum=${item.tracking[0].trackingNumber}`">{{item.tracking[0].trackingNumber}}</a></div>
                <div v-if="item.tracking[0].carrier.toUpperCase().includes('FedEx')"><span class="strong">Tracking: </span><a class="link text-cyan-7" :href="`https://www.fedex.com/apps/fedextrack/?action=track&trackingnumber=${item.tracking[0].trackingNumber}`">{{item.tracking[0].trackingNumber}}</a></div>
                <div v-if="!item.tracking[0].carrier.toUpperCase().includes('UPS') && !item.tracking[0].carrier.toUpperCase().includes('FedEx')"><span class="strong">Tracking: </span>{{item.tracking[0].trackingNumber}}</div>
                <div><span class="strong">Pieces:</span> {{item.tracking[0].pieces}}</div>
                <div><span class="strong">Weight:</span> {{item.tracking[0].weight}}</div>
            </q-card-section>
            <q-separator />
        </q-card>
    </q-dialog>

  <div class="mobileDiv"></div>
</template>

<style scoped>
.btn-consignment-val{height: 20px !important; display: block !important;}
.selectHitBox{position: absolute;  height: 75px; top: -25px; width: 100%;}
</style>
